export default __webpack_public_path__ + "static/img-credit-score-old-vs-new--mobile-fd49684370dd2baa00d0c395b71c7f8e.webp";